import React from 'react'
import { Link, useParams } from 'react-router-dom';
import PrivacyPolicy from '../components/PrivacyPolicy';
import GizlilikPolitikasi from '../components/GizlilikPolitikasi';
import TermsOfUse from '../components/TermsOfUse';
import KullanimSartlari from '../components/KullanimSartlari';
import Kvkk from '../components/Kvkk';

export default function Policy() {
   
        const { policyType } = useParams(); // Get the parameter from the URL

    // Render the appropriate component based on the policyType parameter
    const renderPolicy = () => {
        switch (policyType) {
            case 'privacy-policy':
                return <PrivacyPolicy />;
            case 'gizlilik-politikasi':
                return <GizlilikPolitikasi />;
            case 'terms-of-use':
                return <TermsOfUse />;
            case 'kullanim-sartlari':
                return <KullanimSartlari />;
            case 'kvkk':
                return <Kvkk />;
            default:
                return <div>Policy not found</div>;
        }
    };

    return (
        <div className='items-center justify-center flex flex-col'>
            <div className='flex flex-row items-center justify-center mt-5'>
                <Link to="/policy/privacy-policy" className='text-navy hover:text-blue-700 mx-2'>Privacy Policy</Link>
                <Link to="/policy/terms-of-use" className='text-navy hover:text-blue-700 mx-2'>Terms of Use</Link>
                
                <Link to="/policy/gizlilik-politikasi" className='text-navy hover:text-blue-700 mx-2'>Gizlilik Politikası</Link>    
                <Link to="/policy/kullanim-sartlari" className='text-navy hover:text-blue-700 mx-2'>Kullanım Şartları</Link>
                <Link to="/policy/kvkk" className='text-navy hover:text-blue-700 mx-2'>KVKK</Link>
            </div>
            {renderPolicy()}
        </div>
    );
    
}
